import { IData } from 'components/molecules/GroupPermissionGrid/types';

export const columns: IData[] = [
  {
    name: 'name',
    align: 'left',
    width: '25%',
    title: 'Nome do Usuário',
  },
  {
    name: 'group',
    align: 'left',
    width: '30%',
    title: 'Grupo de usuário',
    editingEnabled: true,
  },
  {
    name: 'modifiedDate',
    align: 'left',
    width: '15%',
    title: 'Data Alteração',
  },
  {
    name: 'modifiedUser',
    align: 'left',
    width: '25%',
    title: 'Usuário Alteração',
  },
];
